import { ColorEnum } from '@/constants/color'
import { isIOS } from '@/constants/environment'
import Button from '@/features/openTabs/components/AccountActionButton'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface SplitSelectionFooterProps {
    totalPrice: string
    canContinue: boolean
    reviewing?: boolean
    onCancel: () => void
    onContinue: () => void
}

const SplitSelectionFooter: FC<SplitSelectionFooterProps> = ({
    totalPrice,
    canContinue,
    reviewing = true,
    onCancel,
    onContinue,
}) => {
    const { t } = useTranslation('app')
    const { styles } = useStyles(stylesheet)

    return (
        <View style={styles.container} testID="open-account-split-footer">
            <View style={styles.total}>
                <Typography.Heading variant="h3">{t('openTabs.summary.total')}</Typography.Heading>
                <Typography.Heading variant="h3">{totalPrice}</Typography.Heading>
            </View>
            <View style={styles.actions}>
                <Button
                    color="secondary"
                    type="outline"
                    onPress={onCancel}
                    style={styles.button}
                    testID="open-account-split-cancel"
                >
                    {t('openTabs.actions.cancel')}
                </Button>
                <Button
                    color="secondary"
                    disabled={!canContinue}
                    onPress={onContinue}
                    style={styles.button}
                    testID="open-account-split-confirm"
                >
                    {t(reviewing ? 'openTabs.actions.confirm' : 'openTabs.actions.continue')}
                </Button>
            </View>
        </View>
    )
}

const stylesheet = createStyleSheet((_, { insets }) => ({
    container: {
        paddingTop: 8,
        paddingHorizontal: 16,
        paddingBottom: isIOS ? Math.max(16, insets.bottom) : 16 + insets.bottom,
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        backgroundColor: ColorEnum.VIOLET_100,
        gap: 12,
    },
    total: {
        minHeight: 42,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingVertical: 8,
        borderBottomWidth: 1,
        borderBottomColor: ColorEnum.GRAY_300,
    },
    actions: { flexDirection: 'row', gap: 16 },
    button: { flex: 1, minHeight: 44, justifyContent: 'center', borderRadius: 8 },
}))

export default SplitSelectionFooter
